import { useState } from 'react';
import classNames from 'classnames';
import { Check } from 'assets/icons';

export default function Checkbox({ checked: propState, onChange }) {
  const [checked, setChecked] = useState(propState);

  function handleClick() {
    setChecked(!checked);
    onChange();
  }

  return (
    <div
      className={classNames('w-6 h-6 mr-2 border-2 rounded', {
        'border-gray': !checked,
        'border-blue bg-blue': checked,
      })}
      onClick={handleClick}
    >
      {checked && <Check className={classNames('text-white')} />}
    </div>
  );
}
